"use strict";
const _ = require('lodash');
_.mixin(require('lodash-uuid'));
// invariants for the entity goes here
const ensureArticleFilterConfig = articleFilterPanelConfig => {
    const result = articleFilterPanelConfig || {};
    const defaultArticleFilters = [
        'useProductCategoriesFacet',
        'useResponsibleForDeliveryFacet',
        'useRequiresAlcoholFacet',
        'useEcoFacet',
        'useCampaignFacet',
        'useOriginFacet',
        'useContainerFacet',
    ];
    defaultArticleFilters.forEach(x => {
        if (result[x] === undefined) {
            result[x] = true;
        }
    });
    return result;
};
const ensureNavbarConfig = shopConfig => {
    const result = _.clone(shopConfig.navbarConfig) || null;
    if (!shopConfig.navbarConfig) {
        return result;
    }
    result.links = result.links.map(x => ({
        ...x,
        id: x.id || _.uuid(),
        subLinks: !_.isEmpty(x.subLinks)
            ? x.subLinks.map(y => ({
                ...y,
                id: y.id || _.uuid(),
            }))
            : [],
    }));
    return result;
};
module.exports = entity => ({
    ...entity,
    navbarConfig: ensureNavbarConfig(entity),
    baseUrl: entity.baseUrl
        ? entity.baseUrl
        : `${entity.subdomain}.flaivymarket.com`,
    usesSupplierCustomer: _.get(entity, 'organization.usesSupplierCustomer', false),
    articleFilterPanelConfig: ensureArticleFilterConfig(entity.articleFilterPanelConfig),
});
